import { render } from "./EmployeeDocumentsView.vue?vue&type=template&id=10b81667&scoped=true"
import script from "./EmployeeDocumentsView.vue?vue&type=script&lang=js"
export * from "./EmployeeDocumentsView.vue?vue&type=script&lang=js"

import "./EmployeeDocumentsView.vue?vue&type=style&index=0&id=10b81667&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10b81667"]])

export default __exports__